import React, { Component } from "react";
import { filter } from "lodash";
import { URL_IMG, CHARM_TYPE } from "../../const";

export default class StoneItem extends Component {
  handleSelectSize() {
    let { handleUpdateState, stone } = this.props;

    handleUpdateState("isShowModalSelectSize", true);
    handleUpdateState("dataStoneItem", stone);
  }

  handleCheckSize() {
    let materials = JSON.parse(localStorage.getItem("materials")) || [];
    let { stone } = this.props;
    let listMaterialCurent = filter(materials, obj => obj.id === stone.id);

    if (listMaterialCurent.length === stone.sizes.length) {
      return true;
    }

    return false;
  }

  render() {
    let { stone } = this.props;
    let arrPrice = [];

    stone.sizes.map(item => {
      arrPrice.push(item.price);
    });

    let price = Math.min.apply(Math, arrPrice);
    let srcImage = `${URL_IMG}${stone.image_design}`;

    return (
      <li>
        <div
          className={`material_list_img ${
            stone.type === CHARM_TYPE ? " image-charm" : ""
          }`}
        >
          <img src={srcImage} alt="" />
        </div>
        <div className="material_list_content">
          <h3>{stone.name}</h3>
          <p>{stone.detail}</p>
          <span className="list_content_price">{price + "円"}</span>
        </div>

        {this.handleCheckSize() ? (
          <button className={`material_list_btn disable`}>選択された</button>
        ) : (
          <button
            className={`material_list_btn`}
            onClick={() => this.handleSelectSize()}
          >
            選択
          </button>
        )}
      </li>
    );
  }
}
